import type { Template } from "@/types";

export const LA_04_H2_V2: Template[] = [
{
    id: "la-04-h2v2-01",
    name: "LA 01 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 39, y: 112, width: 169, height: 254, rotation: 0, imageRotation: 0 },
            { id: "2", x: 215, y: 112, width: 381, height: 254, rotation: 0, imageRotation: 0 },
            { id: "3", x: 678, y: 112, width: 381, height: 254, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1067, y: 112, width: 169, height: 254, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h2v2-02",
    name: "LA 02 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 41, y: 104, width: 180, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 227, y: 104, width: 407, height: 270, rotation: 0, imageRotation: 0 },
            { id: "3", x: 642, y: 104, width: 406, height: 270, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1054, y: 104, width: 180, height: 270, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h2v2-03",
    name: "LA 03 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 93, width: 191, height: 289, rotation: 0, imageRotation: 0 },
            { id: "2", x: 198, y: 93, width: 435, height: 289, rotation: 0, imageRotation: 0 },
            { id: "3", x: 641, y: 93, width: 434, height: 289, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1082, y: 93, width: 191, height: 289, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h2v2-04",
    name: "LA 04 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 41, y: 147, width: 274, height: 182, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 147, width: 273, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 673, y: 32, width: 274, height: 411, rotation: 0, imageRotation: 0 },
            { id: "4", x: 955, y: 32, width: 273, height: 411, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h2v2-05",
    name: "LA 05 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 178, y: 46, width: 281, height: 385, rotation: 0, imageRotation: 0 },
            { id: "2", x: 754, y: 47, width: 404, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 754, y: 257, width: 269, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1029, y: 257, width: 130, height: 172, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h2v2-06",
    name: "LA 06 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 161, y: 51, width: 315, height: 184, rotation: 0, imageRotation: 0 },
            { id: "2", x: 161, y: 242, width: 315, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 700, y: 50, width: 253, height: 376, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 50, width: 253, height: 376, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h2v2-07",
    name: "LA 07 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 166, y: 44, width: 304, height: 182, rotation: 0, imageRotation: 0 },
            { id: "2", x: 166, y: 233, width: 149, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 233, width: 149, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 700, y: 74, width: 512, height: 325, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h2v2-08",
    name: "LA 08 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 42, y: 59, width: 531, height: 357, rotation: 0, imageRotation: 0 },
            { id: "2", x: 580, y: 59, width: 116, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 580, y: 240, width: 116, height: 175, rotation: 0, imageRotation: 0 },
            { id: "4", x: 702, y: 59, width: 531, height: 357, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h2v2-09",
    name: "LA 09 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 38, y: 32, width: 272, height: 411, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 119, width: 318, height: 238, rotation: 0, imageRotation: 0 },
            { id: "3", x: 641, y: 119, width: 318, height: 238, rotation: 0, imageRotation: 0 },
            { id: "4", x: 965, y: 32, width: 272, height: 411, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h2v2-10",
    name: "LA 10 - H2V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h2_v2_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 77, y: 63, width: 132, height: 172, rotation: 0, imageRotation: 0 },
            { id: "2", x: 77, y: 241, width: 132, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 215, y: 63, width: 487, height: 351, rotation: 0, imageRotation: 0 },
            { id: "4", x: 709, y: 63, width: 487, height: 351, rotation: 0, imageRotation: 0 }
    ],
}
];